import { render, staticRenderFns } from "./BLangMenu.vue?vue&type=template&id=0b55987e&scoped=true"
import script from "./BLangMenu.vue?vue&type=script&lang=js"
export * from "./BLangMenu.vue?vue&type=script&lang=js"
import style0 from "./BLangMenu.vue?vue&type=style&index=0&id=0b55987e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b55987e",
  null
  
)

export default component.exports